var ShippingSummarySlotTypes = /* @__PURE__ */ ((ShippingSummarySlotTypes2) => {
  ShippingSummarySlotTypes2["Addresses"] = "addresses";
  ShippingSummarySlotTypes2["ContactDetails"] = "contactDetails";
  ShippingSummarySlotTypes2["Company"] = "company";
  ShippingSummarySlotTypes2["Invoice"] = "invoice";
  ShippingSummarySlotTypes2["ExpressCheckout"] = "expressCheckout";
  return ShippingSummarySlotTypes2;
})(ShippingSummarySlotTypes || {});
export {
  ShippingSummarySlotTypes
};
//# sourceMappingURL=types.js.map
